/* eslint-disable @typescript-eslint/member-ordering */
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  public loadingStatus: Subject<boolean> = new Subject();
  public loadingDescriptionStatus: Subject<string> = new Subject();
  private loadingState = false;
  private loadingDescriptionState = '';

  get loading(): boolean {
    return this.loadingState;
  }

  set loading(value) {
    if (!value) {
      this.loadingDescription = '';
    }

    this.loadingState = value;
    this.loadingStatus.next(value);
  }

  get loadingDescription(): string {
    return this.loadingDescriptionState;
  }

  set loadingDescription(value) {
    this.loadingDescriptionState = value;
    this.loadingDescriptionStatus.next(value);
  }

  setLoading(load: boolean) {
    this.loading = load;
  }
}
